import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useLayoutEffect, useRef, useState } from 'react';
import Icon from 'react-eva-icons';

import { MaterialModal } from '../index';

import { CardSections } from './card';
import styles from './flash-cards.module.scss';

const cx = classnames.bind(styles);

function ExampleModal({ image, sections, onClose, isOpen, ...rest }) {
  return (
    <MaterialModal
      open={isOpen}
      appElementId="root"
      ctaText="Got it"
      closeModal={onClose}
      requestClose={onClose}
      {...rest}
    >
      <Content image={image} sections={sections} />
    </MaterialModal>
  );
}

ExampleModal.propTypes = {
  image: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
};

export default ExampleModal;

function Content({ image, sections }) {
  const containerEl = useRef(null);
  const imageEl = useRef(null);
  const [helper, setHelper] = useState(false);
  const [fitImage, setFitImage] = useState(false);

  const onImgLoad = () => {
    const imageWidth = imageEl.current.naturalWidth;
    const containerWidth = containerEl.current.clientWidth;

    if (imageWidth > containerWidth) {
      setHelper(true);
      return;
    }

    setFitImage(true);
  };

  useLayoutEffect(() => {
    const removeListener = () => {
      containerEl.current.removeEventListener('scroll', scrollListener);
    };

    const scrollListener = () => {
      setHelper(false);
      removeListener();
    };

    containerEl.current.addEventListener('scroll', scrollListener);

    return removeListener;
  }, [containerEl, imageEl]);

  return (
    <div className={styles.modal}>
      <div className={cx({ image: true, fit: fitImage })} ref={containerEl}>
        {helper && (
          <div className={styles.pill}>
            Swipe to see more <Icon size="medium" name="arrow-forward-outline" />
          </div>
        )}
        {image && <img ref={imageEl} src={image} alt="Chart" onLoad={onImgLoad} />}
      </div>
      <CardSections side={sections} />
    </div>
  );
}

Content.propTypes = {
  image: PropTypes.string,
  sections: PropTypes.array.isRequired,
};
